import { render } from "./User.vue?vue&type=template&id=2c8245fb&scoped=true&ts=true"
import script from "./User.ts?vue&type=script&lang=ts"
export * from "./User.ts?vue&type=script&lang=ts"

import "./User.scss?vue&type=style&index=0&id=2c8245fb&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c8245fb"]])

export default __exports__